import React, { useEffect, useState } from 'react';

import { DetailedLifecycleColorMap } from '../constants/detailedLifecyle';
import { IKeyValMap } from '../interfaces/IKeyValMap';
import MetadataService from '../metadata.service';
import { Tag } from './Tag';

/**
 *
 * @param {string} detailedLifecycle e.g., RUW_POST_DECISION
 * @returns {React.ReactNode} React Node showing the displayText e.g., 'RUW Post Decision'. null if the mapping does not exist.
 */
export const ApplicationDetailedLifecycle = ({
  detailedLifecycle,
}: {
  detailedLifecycle: string;
}) => {
  const [applicationDetailedLifecycle, setApplicationDetailedLifecycle] =
    useState<IKeyValMap>({});

  useEffect(() => {
    let mounted = true;

    async function fetchLifecycles() {
      try {
        const data = await MetadataService.getApplicationDetailedLifecycles();
        if (mounted) {
          setApplicationDetailedLifecycle(data);
        }
      } catch (error) {
        console.error('Failed to fetch application lifecycles:', error);
      }
    }

    fetchLifecycles();
    return () => {
      mounted = false;
    };
  }, []);

  if (detailedLifecycle in DetailedLifecycleColorMap) {
    const label =
      applicationDetailedLifecycle[detailedLifecycle]?.displayText || '';
    return (
      <Tag color={DetailedLifecycleColorMap[detailedLifecycle]}>{label}</Tag>
    );
  }
  return applicationDetailedLifecycle[detailedLifecycle]?.displayText ?? '-';
};
